import { Result, ShowResultAlertDialog } from './base/Result';

export default class SysProtocol {
  static pIns = new SysProtocol();
  static ins() { return this.pIns; }

  constructor(){
    console.log("Sys Protocol init.");
  }

  reqGetAnalysisUrl (storeId, pageName, callback) {
    this.onGetAnalysisUrlCallback = callback;

    //for test
    let url = "";
    switch(pageName){
      case "furniture":
        url = "https://public.tableau.com/views/TaipeiHandsOnTableauv10_16050621385850/sheet0?:language=zh-Hant&:display_count=y&publish=yes&:origin=viz_share_link";
        break;
      case "rfm":
        url = "https://public.tableau.com/views/__v10_5_WEB_15906465781420/RFMHeatmap?:display_count=y&:origin=viz_share_link";
        break;
      case "line":
        url = "https://public.tableau.com/views/__15741600609290/Line?:embed=y&:display_count=y&publish=yes&:origin=viz_share_link";
        break;
      case "report":
        url = "https://public.tableau.com/views/__15741600609290/sheet2?:embed=y&:display_count=y&publish=yes&:origin=viz_share_link";
        break;
      case "pos":
      default:
        url = "https://public.tableau.com/views/__15741600609290/POS?:display_count=y&publish=yes&:origin=viz_share_link";
        break;
    }
    let resp = {
      Url: url
    };
    this.onGetAnalysisUrl(Result.OK, resp);
  }

  onGetAnalysisUrl (rs, resp) {
    if(rs !== Result.OK){
      ShowResultAlertDialog(rs);
      return;
    }

    this.onGetAnalysisUrlCallback(resp.Url);
  }

  reqGetPBIAnalysisUrl (storeId, pageName, callback) {
    this.onGetPBIAnalysisUrlCallback = callback;

    //for test
    let url = "";
    switch(pageName){
      case "supplier":
      default:
        url = "https://app.powerbi.com/view?r=eyJrIjoiODM4ZTE3YjEtZmE4ZS00NGM0LThiZjAtOWY5YjlkZDQyOWUxIiwidCI6ImM1ZmIyOGE5LWVlNzctNDhlNC04ZjA4LWExZDNlMTk3NjI3NiIsImMiOjEwfQ%3D%3D&pageName=ReportSection2";
        break;
    }
    let resp = {
      Url: url
    };
    this.onGetPBIAnalysisUrl(Result.OK, resp);
  }

  onGetPBIAnalysisUrl (rs, resp) {
    if(rs !== Result.OK){
      ShowResultAlertDialog(rs);
      return;
    }

    this.onGetPBIAnalysisUrlCallback(resp.Url);
  }
}